'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getAbsoluteBarrierFromContract = require('./getAbsoluteBarrierFromContract');

var _getAbsoluteBarrierFromContract2 = _interopRequireDefault(_getAbsoluteBarrierFromContract);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract, lastTickQuote) {
    return (0, _getAbsoluteBarrierFromContract2.default)(contract, lastTickQuote, 'barrier2');
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/barrier/barrier2FromContract.js
// module id = 49
// module chunks = 0